<template>
  <div>
    <div class="left-container">
      <group-list @selected="selected" />
    </div>
    <div class="right-container">
      <tag-list :group-id="groupId" />
    </div>
  </div>
</template>

<script>
import GroupList from '@/pages/system/tags/components/GroupList';
import TagList from '@/pages/system/tags/components/TagList';

export default {
  components: {
    GroupList,
    TagList
  },
  data() {
    return {
      groupId: null
    };
  },
  methods: {
    selected(value) {
      this.groupId = value;
    }
  }
};
</script>
<style lang="less" scoped>
.left-container {
  width: 300px;
  float: left;
  margin-right: 16px;
}
.right-container {
  width: calc(~'100% - 316px');
  float: left;
}
</style>
